import Axios from "axios";
import Cookies from "js-cookie";

class BankInvites {
  async getAll(pageNumber, totalCount, searchText) {
    const token = Cookies.get("jwt");
    const configAPi = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const r = await Axios.post(
        process.env.REACT_APP_STAGE === "production"
          ? `${process.env.REACT_APP_API_BASE_URL}/bank-invites/all`
          : `${process.env.REACT_APP_LOCAL_API_URL}/bank-invites/all`,
        { pageNumber, totalCount, searchText },
        configAPi
      );
      return r.data;
    } catch (err) {
      throw err;
    }
  }
  async updateInviteStatus(invite_id, status) {
    const token = Cookies.get("jwt");
    const configAPi = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      const r = await Axios.post(
        process.env.REACT_APP_STAGE === "production"
          ? `${process.env.REACT_APP_API_BASE_URL}/bank-invites/update-status`
          : `${process.env.REACT_APP_LOCAL_API_URL}/bank-invites/update-status`,
        { invite_id, status },
        configAPi
      );
      return r.data;
    } catch (err) {
      throw err;
    }
  }
}

export default new BankInvites();
